export const CLUB = "C";
export const ESTADIO = "E";
export const PERSONA = "P";
export const PARTIDO = "R";
export const SUSTITUCION = "S";
export const TORNEO = "T";
export const EXPULSION = "X";
